module.exports = __webpack_public_path__ + "img/rsr.4fed1610.svg";